import { useEffect, type RefObject } from 'react'

// Calls `onDismiss` when the user interacts away from `ref`:
// click-outside or Escape. Listeners only attach while `isActive`.
export const useDismissOnOutside = (
  ref: RefObject<HTMLElement>,
  isActive: boolean,
  onDismiss: () => void,
) => {
  useEffect(() => {
    if (!isActive) return undefined

    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onDismiss()
      }
    }
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onDismiss()
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [isActive, onDismiss, ref])
}
